import {
	ChangePasswordPath,
	ChangePasswordPayload,
	EnableMFAPath,
	IUserLogin,
	LoginPath,
	LoginResult,
	LogoutPath,
	MFAConfigPayload,
	MFAConfigResultPayload,
	MFAResetPayload,
	ResetMFAPath,
	ResetPasswordPath,
	ResetPasswordRequest,
	SignUpPath,
	UserConfig,
	VerifyMFATokenPath,
	mfaToken,
	urlCombine,
} from 'ihub/common';
import {
	authAPI,
	buildURL,
	handleResponse,
	isURLSet,
	standardGet,
	standardPost,
} from '../classes/http-helper-const';
import AppRoutes from '../enums/app-routes';
import dispatchSnackbar from '../functions/dispatch-snackbar';
import { ClearSessionUser } from '../functions/session-functions';

export class AuthHttpService {
	async login(
		login: IUserLogin,
		options?: {
			success?: (response?: LoginResult) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = urlCombine(authAPI, LoginPath);
		const response = await standardPost(url, login);
		await handleResponse(response, LoginPath, UserConfig.name, options);
	}

	async enableMFA(options?: {
		success?: (response?: MFAConfigResultPayload) => void | Promise<void>;
		error?: (data: any) => void | Promise<void>;
	}) {
		isURLSet();
		const url = urlCombine(authAPI, EnableMFAPath);
		const response = await standardPost(url, new MFAConfigPayload());
		await handleResponse(response, LoginPath, UserConfig.name, options);
	}

	async submitOTP(
		otp: string,
		options?: {
			success?: (response?: any) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		const url = buildURL('Auth', [VerifyMFATokenPath], [{ key: mfaToken, value: otp }]);
		const response = await standardGet(url);
		await handleResponse(response, VerifyMFATokenPath, UserConfig.name, options);
	}

	async logout() {
		isURLSet();
		const url = urlCombine(authAPI, LogoutPath);
		const response = await standardGet(url);
		await handleResponse(response, LogoutPath, UserConfig.name, {
			success: () => {
				ClearSessionUser();
				window.location.pathname = AppRoutes.Login;
			},
			error: err => {
				dispatchSnackbar({
					message: err.message ?? err,
					severity: 'error',
				});
			},
		});
	}

	async signUp(
		newUser: UserConfig,
		options?: {
			success?: (response?: any) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = urlCombine(authAPI, SignUpPath);
		const response = await standardPost(url, newUser);
		await handleResponse(response, SignUpPath, UserConfig.name, options);
	}

	async resetPassword(
		resetPasswordRequest: ResetPasswordRequest,
		options?: {
			success?: (response?: any) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = urlCombine(authAPI, ResetPasswordPath);
		const response = await standardPost(url, resetPasswordRequest);
		await handleResponse(response, ResetPasswordPath, UserConfig.name, options);
	}

	async changePassword(
		changePasswordPayload: ChangePasswordPayload,
		options?: {
			success?: (response?: any) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = urlCombine(authAPI, ChangePasswordPath);
		const response = await standardPost(url, changePasswordPayload);
		await handleResponse(response, ChangePasswordPath, UserConfig.name, options);
	}

	async resetMfa(
		mfaResetPayload: MFAResetPayload,
		options?: {
			success?: (response?: any) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = urlCombine(authAPI, ResetMFAPath);
		const response = await standardPost(url, mfaResetPayload);
		await handleResponse(response, ResetMFAPath, UserConfig.name, options);
	}
}
